import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import { familyInitDataStore } from 'src/store/familyInfo';
import '../style.scss';

interface Props {}
const FamilyDescription: FC<Props> = () => {
  const checkTypeEvt = () => {};
  const familyInitResult = familyInitDataStore((state: any) => state.result);
  const familyInitBind = familyInitDataStore((state: any) => state.bind);
  const checkClickEvt = (e: any, status: string, field?: string) => {
    if (field) {
      const vType = status === 'on' ? false : true;
      familyInitResult[field] = vType;
      familyInitBind(familyInitResult);
    }
  };

  return (
    <div className="_creditcard_add_info_description">
      <div className="_grid">
        <div className="_label">
          <div className="_row">
            <div className="_col _col_se_3">
              <div className="_tit">공제대상자</div>
            </div>
            <div className="_col _col_se_4">
              <div className="_tit">공제대상 교육기관</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_tit">공제한도</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_tit">공제대상금액</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_tit">세액공제</div>
            </div>
          </div>
        </div>

        <div className="_content">
          <div className="_row">
            <div className="_col _col_se_3">
              <div className="_cont _left">
                근로자 본인의 교육비
                <br />
                (대학원생 포함)
              </div>
            </div>
            <div className="_col _col_se_4">
              <div className="_cont _left">
                <div className="item">
                  ∙유아교육법, 초ㆍ중등교육법, 고등교육법 및 특별법에 따른 학교
                </div>
                <div className="item">
                  ∙평생교육법에 따른 고등학교졸업 이하의 학력이 인정되는 학교형태의 평생교육시설
                </div>
                <div className="item">
                  ∙평생교육법에 따른 전공대학 및 원격대학 형태의 평생교육시설, 학위취득과정
                </div>
                <div className="item">
                  ∙국외교육기관 ∙대학(원격대학 및 학위취득과정 포함) 또는 대학원의 1학기 이상에
                  해당하는 교육과정과 시간제 과정 ∙직업능력개발훈련시설 (수강료에서 근로자
                  수강지원금 차감함)
                </div>
                <div className="item">∙학자금 대출의 원리금 상환액</div>
              </div>
            </div>
            <div className="_col _col_se_3 ">
              <div className="_cont _mid">한도 없음</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont _left">
                근로제공기간 동안
                <br /> 지출한 해당
                <br /> 교육비 전액
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDescription;
